export default "__VITE_ASSET__zPgl7JGh__"